(function () {
  let isEnforcing = false;

  async function checkAndEnforceGWP() {
    if (isEnforcing) return;

    let cart;
    try {
      cart = await fetch('/cart.js').then(function (r) { return r.json(); });
    } catch (e) {
      return;
    }

    var gwpItems = cart.items.filter(function (item) {
      return item.title.toLowerCase().includes('gwp') && item.original_price === 0;
    });
    if (gwpItems.length === 0) return;

    var EXCLUDED_TITLE = 'Free Unlimited Return + Package Protection Valid in US';
    var hasQualifyingItem = cart.items.some(function (item) {
      return item.original_price > 0 && item.title !== EXCLUDED_TITLE;
    });
    if (hasQualifyingItem) return;

    isEnforcing = true;

    var updates = {};
    gwpItems.forEach(function (item) {
      updates[item.variant_id] = 0;
    });

    var cartDrawerEl = document.querySelector('cart-drawer');
    var mainCartEl = document.querySelector('main-cart');
    var sectionId = (cartDrawerEl && cartDrawerEl.dataset && cartDrawerEl.dataset.sectionId)
      || (mainCartEl && mainCartEl.dataset && mainCartEl.dataset.sectionId);
    var sections = sectionId ? (sectionId + ',cart-icon-bubble') : 'cart-icon-bubble';

    try {
      var parsedState = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          updates: updates,
          sections: sections,
          sections_url: window.location.pathname
        })
      }).then(function (r) { return r.json(); });

      if (parsedState.sections && sectionId && parsedState.sections[sectionId]) {
        var parser = new DOMParser();
        var parsed = parser.parseFromString(parsedState.sections[sectionId], 'text/html');
        var container = cartDrawerEl || mainCartEl;
        if (container) {
          [
            '.cart-content-items',
            '.drawer__footer-bottom-total',
            '.main-cart-items',
            '.main-cart-totals',
            '.free-shipping-bar'
          ].forEach(function (sel) {
            var src = parsed.querySelector(sel);
            var dst = container.querySelector(sel) || document.querySelector(sel);
            if (src && dst) dst.innerHTML = src.innerHTML;
          });
        }
      }

      if (parsedState.sections && parsedState.sections['cart-icon-bubble']) {
        var bubbleParser = new DOMParser();
        var parsedBubble = bubbleParser.parseFromString(
          parsedState.sections['cart-icon-bubble'],
          'text/html'
        );
        var newBubble = parsedBubble.querySelector('.shopify-section');
        if (newBubble) {
          var bubbleEl = document.getElementById('cart-icon-bubble');
          var bubbleMobileEl = document.getElementById('cart-icon-bubble-mobile');
          if (bubbleEl) bubbleEl.innerHTML = newBubble.innerHTML;
          if (bubbleMobileEl) bubbleMobileEl.innerHTML = newBubble.innerHTML;
        }
      }

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            itemCount: parsedState.item_count != null ? parsedState.item_count : 0,
            source: 'gwp-guard'
          }
        }
      }));

    } catch (e) {
      console.error('[gwp-cart-guard]', e);
    } finally {
      isEnforcing = false;
    }
  }

  document.addEventListener('DOMContentLoaded', checkAndEnforceGWP);
  document.addEventListener('nextsky:cart:added', checkAndEnforceGWP);
})();
